/* CRO 13.10.2026 - Clarity-Report KW 42, Befund 3.
   Ergaenzt das Mengenfeld um inputmode="numeric" (Zifferntastatur auf dem Handy)
   und markiert den vorhandenen Wert beim Antippen, damit eine neue Zahl direkt
   getippt werden kann - statt den Plus-Knopf 164-mal zu druecken.
   Aendert das Verhalten der Plus-/Minus-Knoepfe nicht. */
(function () {
  'use strict';

  var SELEKTOR = 'input.quantity__input';

  function aufwerten(feld) {
    if (!feld || feld.dataset.wwdMengenfeld) return;
    feld.dataset.wwdMengenfeld = '1';
    if (!feld.getAttribute('inputmode')) feld.setAttribute('inputmode', 'numeric');
    var markieren = function () {
      try { feld.select(); } catch (e) {}
    };
    feld.addEventListener('focus', markieren);
    feld.addEventListener('click', markieren);
  }

  function durchlauf() {
    try {
      var felder = document.querySelectorAll(SELEKTOR);
      for (var i = 0; i < felder.length; i++) aufwerten(felder[i]);
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', durchlauf);
  } else {
    durchlauf();
  }

  /* Shopify tauscht den Mengenblock bei Variantenwechsel und im Warenkorb aus.
     Entprellt, damit der Beobachter nicht bei jeder DOM-Aenderung laeuft. */
  try {
    var wartend = false;
    new MutationObserver(function () {
      if (wartend) return;
      wartend = true;
      setTimeout(function () { wartend = false; durchlauf(); }, 200);
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
